import { CarConfig } from "stores/wizard/config";
import { carVendorCoupons } from "./carVendorCoupons";
import { DayName } from "uitk-react-date-picker";
import { CarsVendorCodes } from "src/components/flexComponents/WizardCarPWA/components/CarsVendorCodes";
import { locKeys } from "components/flexComponents/WizardCarPWA/components/l10n";
import { carTimesValues } from "src/components/flexComponents/WizardCarPWA/config/time/carTimesValues";
import { gtConfig } from "./gt/gtConfig";
import { TRAVELERS_HIDDEN_INPUT_TYPE } from "src/components/shared/TravelersField";

const travelersConfig = {
  icon: "person",
  labelToken: "wizard.roomPicker.travelers.title",
  dialogTitleToken: "wizard.roomPicker.travelers.title",
  dialogCancelLabelToken: "wizard.roomPicker.closeButton.a11yLabel",
  childrenCaptionToken: "wizard.roomPicker.children.withInfants.caption",
  infantsCaptionToken: "wizard.roomPicker.infants.caption",
  youngestChildAgeTextToken: "",
  youngestInfantAgeTextToken: "wizard.roomPicker.youngestChildAge.text",
  invalidLessThanNTravelersMessageToken: "wizard.travelers.warning.invalidNumberOfTravelers.text",
  invalidUnattendedInfantOnLapMessageToken: "wizard.travelers.warning.unattendedInfantOnLap.text",
  minBookableTravelers: 1,
  maxBookableTravelers: 6,
  minChildAge: 2,
  maxChildAge: 17,
  minInfantAge: 0,
  maxInfantAge: 1,
  minAdultsPerRoom: 1,
  maxAdultsPerRoom: 6,
  minChildrenPerRoom: 0,
  maxChildrenPerRoom: 6,
  minInfantsPerRoom: 0,
  maxInfantsPerRoom: 6,
  maxRooms: 6,
  withRooms: true,
  withFlight: true,
  withInfants: true,
  hiddenInputType: TRAVELERS_HIDDEN_INPUT_TYPE.CAR_SEARCH
};

export const carConfig: CarConfig = {
  navigation: {
    tabIcon: "lob_cars",
    tabTitleToken: "wizard.car.tab.title.label"
  },
  lastSearch: {
    useLastSearchForSingleLOB: false,
    lastSearchKey: "lastSearchCookie",
    lobKey: "wizard-car-pwa"
  },
  location: {
    destination: {
      inputName: "locn2",
      icon: "place",
      labelToken: "wizard.car.dropOffLocation.label",
      typeaheadLabelToken: "wizard.car.dropOffLocation.placeholder",
      invalidLocationMessageKey: "wizard.destination.warning.invalidDestination.text",
      invalidOriginSameAsDestinationKey: "",
      pwaDialogQueryParam: "destination-car",
      essAdapterConfig: {
        lob: "CARS",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta",
        maxResults: 7,
        regionType: 2047
      }
    },
    origin: {
      inputName: "locn",
      icon: "place",
      labelToken: "wizard.car.pickUpLocation.label",
      typeaheadLabelToken: "wizard.car.pickUpLocation.placeholder",
      invalidLocationMessageKey: "wizard.origin.warning.invalidOrigin.text",
      pwaDialogQueryParam: "origin-car",
      essAdapterConfig: {
        lob: "CARS",
        client: "HotelsLandingPage",
        features: "ta_hierarchy|postal_code|contextual_ta",
        maxResults: 7,
        regionType: 2047
      }
    }
  },
  date: {
    ISOSubmissionSupport: false,
    format: "yyyy-MM-dd",
    submissionFormat: "dd-MM-yyyy",
    firstDayOfWeek: DayName.SUN,
    daysBookableInAdvance: 500,
    midnightBookingOffset: 4,
    maxDaysRange: 30,
    invalidStartDateMessageToken: "wizard.datePicker.warning.invalidPickupDate.text",
    invalidEndDateMessageToken: "wizard.datePicker.warning.invalidDropoffDate.text",
    invalidMaxDatesRangeMessageToken: "wizard.datePicker.warning.maxDatesRange.text",
    invalidStartDateOutOfRangeMessageToken: "",
    invalidEndDateOutOfRangeMessageToken: "",
    invalidStartTimeMessageToken: "wizard.car.time.pickup.invalid",
    start: {
      labelToken: "wizard.car.pickUpDate.label"
    },
    end: {
      labelToken: "wizard.car.dropOffDate.label"
    },
    queryParam: {
      start: "date1",
      end: "date2"
    },
    dialogId: "pick-up-drop-off"
  },
  form: {
    action: "/carsearch",
    submitButton: {
      locToken: "wizard.submit.label"
    }
  },
  carType: "DEFAULT",
  clientID: 0,
  residenceID: "",
  carTimesValues,
  defaultShowingTime: "1030AM",
  age: 30,
  heading: {
    fixedTitle: false,
    lobSubtitleBreakPoint: "on",
    locToken: "wizard.mobile.label.car"
  },
  vendors: {
    NO_PREFERENCE: {
      vendorCode: CarsVendorCodes.NO_PREFERENCE,
      couponInfo: carVendorCoupons.NO_PREFERENCE,
      locKey: locKeys.noPreference,
      includeInDropdown: true
    },
    AC: {
      vendorCode: CarsVendorCodes.ACE_RENT_A_CAR,
      couponInfo: carVendorCoupons.AC,
      locKey: locKeys.aceRentACarCompany,
      includeInDropdown: true
    },
    AD: {
      vendorCode: CarsVendorCodes.ADVANTAGE_RENT_A_CAR,
      couponInfo: carVendorCoupons.AD,
      locKey: locKeys.advantageRentACarCompany,
      includeInDropdown: true
    },
    AL: {
      vendorCode: CarsVendorCodes.ALAMO_RENT_A_CAR,
      couponInfo: carVendorCoupons.AL,
      locKey: locKeys.alamoRentACarCompany,
      includeInDropdown: true
    },
    ZI: {
      vendorCode: CarsVendorCodes.AVIS,
      couponInfo: carVendorCoupons.ZI,
      locKey: locKeys.avisCompany,
      includeInDropdown: true
    },
    ZD: {
      vendorCode: CarsVendorCodes.BUDGET,
      couponInfo: carVendorCoupons.ZD,
      locKey: locKeys.budgetCompany,
      includeInDropdown: true
    },
    ZR: {
      vendorCode: CarsVendorCodes.DOLLAR_RENT_A_CAR,
      couponInfo: carVendorCoupons.ZR,
      locKey: locKeys.dollarRentACarCompany,
      includeInDropdown: true
    },
    EY: {
      vendorCode: CarsVendorCodes.ECONOMY_RENT_A_CAR,
      couponInfo: carVendorCoupons.EY,
      locKey: locKeys.economyRentACarCompany,
      includeInDropdown: true
    },
    ET: {
      vendorCode: CarsVendorCodes.ENTERPRISE,
      couponInfo: carVendorCoupons.ET,
      locKey: locKeys.enterpriseCompany,
      includeInDropdown: true
    },
    EP: {
      vendorCode: CarsVendorCodes.EUROPCAR,
      couponInfo: carVendorCoupons.EP,
      locKey: locKeys.europcarCompany,
      includeInDropdown: true
    },
    FX: {
      vendorCode: CarsVendorCodes.FOX_RENT_A_CAR,
      couponInfo: carVendorCoupons.FX,
      locKey: locKeys.foxRentalCarsCompany,
      includeInDropdown: true
    },
    ZE: {
      vendorCode: CarsVendorCodes.HERTZ,
      couponInfo: carVendorCoupons.ZE,
      locKey: locKeys.hertzCompany,
      includeInDropdown: true
    },
    MW: {
      vendorCode: CarsVendorCodes.MIDWAY_CAR_RENTAL,
      couponInfo: carVendorCoupons.MW,
      locKey: locKeys.midwayCarRentalCompany,
      includeInDropdown: true
    },
    ZL: {
      vendorCode: CarsVendorCodes.NATIONAL_CAR_RENTAL,
      couponInfo: carVendorCoupons.ZL,
      locKey: locKeys.nationalCarRentalCompany,
      includeInDropdown: true
    },
    NU: {
      vendorCode: CarsVendorCodes.NU_CAR,
      couponInfo: carVendorCoupons.NU,
      locKey: locKeys.nuCarCompany,
      includeInDropdown: true
    },
    ZA: {
      vendorCode: CarsVendorCodes.PAYLESS,
      couponInfo: carVendorCoupons.ZA,
      locKey: locKeys.paylessCompany,
      includeInDropdown: true
    },
    RO: {
      vendorCode: CarsVendorCodes.ROUTES_CAR_RENTAL,
      couponInfo: carVendorCoupons.RO,
      locKey: locKeys.routesCarRental,
      includeInDropdown: true
    },
    SX: {
      vendorCode: CarsVendorCodes.SIXT_CAR_RENTAL,
      couponInfo: carVendorCoupons.SX,
      locKey: locKeys.sixtCompany,
      includeInDropdown: true
    },
    ZT: {
      vendorCode: CarsVendorCodes.THRIFTY_CAR_RENTAL,
      couponInfo: carVendorCoupons.ZT,
      locKey: locKeys.thriftyCarRentalCompany,
      includeInDropdown: true
    },
    SV: {
      vendorCode: CarsVendorCodes.U_SAVE,
      couponInfo: carVendorCoupons.SV,
      locKey: locKeys.uSaveCompany,
      includeInDropdown: true
    },
    SC: {
      vendorCode: CarsVendorCodes.SILVERCAR,
      couponInfo: carVendorCoupons.SC,
      locKey: locKeys.silvercar,
      includeInDropdown: true
    }
  },
  elementId: "wizard-car-pwa",
  gtConfig: { ...gtConfig },
  travelers: { ...travelersConfig },
  subLOB: {
    fromAirport: {
      travelers: { ...travelersConfig }
    },
    toAirport: {
      travelers: { ...travelersConfig }
    }
  }
};
